import type {
  CreateWorkshopAppointmentDto,
  FindAllWorkshopAppointmentsQuery,
  UpdateWorkshopAppointmentDto,
  WorkshopAppointment,
} from '@/entities/workshop-appointments/workshop-appointment.entity';
import type { MigrateBlockerToWorkshopAppointmentDto } from '@carvia/ros-client-types';
import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import { Service } from './http-service';

class WorkshopAppointmentsService extends Service<
  WorkshopAppointment,
  CreateWorkshopAppointmentDto,
  UpdateWorkshopAppointmentDto
> {
  async getAllWithQuery(
    query: FindAllWorkshopAppointmentsQuery,
  ): Promise<PaginatedResponse<WorkshopAppointment>> {
    const res = await this.httpClient.get<PaginatedResponse<WorkshopAppointment>>(this.endpoint, {
      params: query,
    });
    return res.data;
  }

  async getTotalCostsByCarId(carId: string): Promise<number> {
    const res = await this.httpClient.get<{ totalCosts: number }>(
      `${this.endpoint}/cars/${carId}/total-costs`,
    );
    return Number(res.data.totalCosts ?? 0);
  }

  async migrateFromBlocker(allocationId: string, data: MigrateBlockerToWorkshopAppointmentDto) {
    const res = await this.httpClient.post<WorkshopAppointment>(
      `${this.endpoint}/from-blocker/${allocationId}`,
      data,
    );
    return res.data;
  }
}

export const workshopAppointmentsService = new WorkshopAppointmentsService(
  '/workshop-appointments',
);
